module.exports = __webpack_public_path__ + "static/media/nagconcept.5b2fb346.jpg";